import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';

@Component({
  selector: 'contact-filter',
  templateUrl: './contact-filter.component.html',
    styleUrls: ['./contact-filter.component.less',
        '../../../style/expand-collapse-panel.component.less',
        '../../../style/form.component.less' ],
    standalone: false
})
export class ContactFilterComponent implements OnInit {
    @Input('chipSeparatorKeyCodes') separatorKeysCodes: number[] = [];
    @Output() outputFilter = new EventEmitter<ContactsFilter>();
    form!: FormGroup;
    addOnBlur = true;
    selectable = true;
    removable = true;

    contactIds : string[] = [];
    contactTypes: string[] = [];
    contactNames: string[] = [];
    contactFirstNames: string[] = [];
    contactLastNames: string[] = [];
    contactEMails: string[] = [];
    contactPhones: string[] = [];
    contactPositions: string[] = [];

    constructor(
        private http: HttpClient,
        private fb: FormBuilder
    ) {
    }

    ngOnInit() {
        this.createForm();
    }

    createForm() {
        this.form = this.fb.group({
        });
    }

    changeTypeButton() {
        return this.contactIds.length < 1 && this.contactTypes.length < 1
            && this.contactNames.length < 1 && this.contactFirstNames.length < 1
            && this.contactLastNames.length < 1 && this.contactEMails.length < 1
    }

    applyFilter(event: MatChipInputEvent, list: string): void {
        const input = event.input;
        const value = event.value;
        if ((value || '').trim()) {
            switch (list) {
                case 'contactIds':
                    this.contactIds.push(value.replace('+', '').trim()); break;
                case 'contactTypes':
                    this.contactTypes.push(value.replace('+', '').trim()); break;
                case 'contactNames':
                    this.contactNames.push(value.replace('+', '').trim()); break;
                case 'contactFirstNames':
                    this.contactFirstNames.push(value.replace('+', '').trim()); break;
                case 'contactLastNames':
                    this.contactLastNames.push(value.replace('+', '').trim()); break;
                case 'contactEMails':
                    this.contactEMails.push(value.replace('+', '').trim());
                    break;
            }
        }
        // Reset the input value
        if (input) {
            input.value = '';
        }
    }

    remove(item: string, list: string): void {
        let index = -1
        switch (list) {
            case 'contactIds':
                index = this.contactIds.indexOf(item);
                if (index >= 0)
                    this.contactIds.splice(index, 1);
                break;
            case 'contactTypes':
                index = this.contactTypes.indexOf(item);
                if (index >= 0)
                    this.contactTypes.splice(index, 1);
                break;
            case 'contactNames':
                index = this.contactNames.indexOf(item);
                if (index >= 0)
                    this.contactNames.splice(index, 1);
                break;
            case 'contactFirstNames':
                index = this.contactFirstNames.indexOf(item);
                if (index >= 0)
                    this.contactFirstNames.splice(index, 1);
                break;
            case 'contactLastNames':
                index = this.contactLastNames.indexOf(item);
                if (index >= 0)
                    this.contactLastNames.splice(index, 1);
                break;
            case 'contactEMails':
                index = this.contactEMails.indexOf(item);
                if (index >= 0)
                    this.contactEMails.splice(index, 1);
                break;
        }
    }

    onFilter() {
        const filter: ContactsFilter = {
            'ContactID': this.contactIds,
            'ContactType': this.contactTypes,
            'ContactEMail': this.contactEMails,
            'ContactName': this.contactNames,
            'ContactFirstName': this.contactFirstNames,
            'ContactLastName': this.contactLastNames,
            'ContactPosition': [],
            'ContactPhone': []
        }
        this.outputFilter.emit(filter);
    }
}
